import { FC } from 'react'
import { isUndefined } from 'lodash'

import {
  chain,
  CheckboxSelect,
  FilterButton,
  useDropdown,
} from '@revolut-internal/ui-kit'

import { useOptionsWithSelectedOnTop } from '../../hooks/useOptionsWithSelectedOnTop'

import { MIN_VALUES_FOR_SEARCHABLE } from './consts'
import { FilterPropsMultiple } from './types'

export const MultiSelectFilter: FC<FilterPropsMultiple<string[]>> = ({
  options,
  label,
  value,
  width = 400,
  loadingState,
  isSearchable,
  renderOption,
  onChange,
}) => {
  const dropdown = useDropdown()
  const arrayValue = Array.isArray(value) ? value : []
  const hasValue = arrayValue.length > 0
  const hasNestedOptions = options.some(
    option => 'children' in option && option.children.length,
  )

  const sortedOptions = useOptionsWithSelectedOnTop(options, value)

  const handleClear = () => {
    onChange?.([])
    dropdown.toggle(false)
  }

  return (
    <>
      <FilterButton
        {...dropdown.getAnchorProps()}
        useIcon="Filter"
        active={hasValue}
        aria-haspopup="listbox"
        aria-expanded={dropdown.state}
        aria-label={label}
        role="combobox"
        onClear={hasValue ? handleClear : undefined}
      >
        {chain(label, arrayValue.length || null)}
      </FilterButton>

      <CheckboxSelect
        {...dropdown.getTargetProps()}
        searchable={
          hasNestedOptions ||
          (!isUndefined(isSearchable)
            ? isSearchable
            : options.length >= MIN_VALUES_FOR_SEARCHABLE)
        }
        type="confirm"
        width={width}
        options={sortedOptions}
        value={arrayValue}
        labelList={label}
        loadingState={loadingState}
        onChange={onChange}
      >
        {renderOption}
      </CheckboxSelect>
    </>
  )
}
